module.exports = __webpack_public_path__ + "img/Jessica.84ee8aa4.jpg";